import { getDefinedUrlParams } from "@libs/utils";
import { ServiceBase } from "services/base-service";
import type { ITranslationLog } from "features/workspaces/types";
import type { ITranslationUpdateParams } from "../types";

interface IValidationError {
  // attemptedValue: null;
  // customState: null;
  // errorCode: null;
  errorMessage: string;
  // formattedMessagePlaceholderValues: null;
  propertyName: string;
  // severity: 0;
}

class TranslationService extends ServiceBase {
  constructor() {
    super();

    this.baseUrl = `${this.baseUrl}/translation`;
  }

  async saveTranslation(
    translation: ITranslationUpdateParams,
    abortController?: AbortController,
  ): Promise<{ isValid: boolean; errors: IValidationError[]; ruleSetsExecuted: string[] }> {
    const response = await this.sendPost("", translation, abortController);

    return response;
  }

  async autoApproveFile(fileId: number, abortController?: AbortController): Promise<{ id: string }> {
    const response = await this.sendPost("/auto-approve-file", { fileId: Number(fileId) }, abortController);

    return response;
  }

  async getLogs(translationItemId: number, abortController?: AbortController): Promise<ITranslationLog[]> {
    const params = {
      translationItemId,
    };

    const url = `/get-logs?${getDefinedUrlParams(params)}`;
    const response = await this.sendGet(url, abortController);

    return response;
  }
}

const translationService = new TranslationService();

export { translationService };
